import React, { SVGProps } from 'react';

const TrendingIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M7.68929 1.40763C7.96786 1.14691 8.4 1.15048 8.67857 1.4112C9.66429 2.3362 10.5893 3.33263 11.4536 4.4112C11.8464 3.89691 12.2929 3.3362 12.775 2.87906C13.0571 2.61477 13.4929 2.61477 13.775 2.88263C15.0107 4.0612 16.0571 5.61834 16.7929 7.09691C17.5179 8.55406 18 10.0433 18 11.0933C18 15.6505 14.4357 19.5005 10 19.5005C5.51429 19.5005 2 15.6469 2 11.0898C2 9.71834 2.63571 8.04334 3.62143 6.3862C4.61786 4.70406 6.025 2.95048 7.68929 1.40763ZM10.0607 16.0719C10.9643 16.0719 11.7643 15.8219 12.5179 15.3219C14.0214 14.2719 14.425 12.1719 13.5214 10.5219C13.3607 10.2005 12.95 10.1791 12.7179 10.4505L11.8179 11.4969C11.5821 11.7683 11.1571 11.7612 10.9357 11.4791C10.3464 10.7291 9.29286 9.38977 8.69286 8.62906C8.46786 8.34334 8.03929 8.33977 7.81071 8.62548C6.60357 10.1433 5.99643 11.1005 5.99643 12.1755C6 14.6219 7.80714 16.0719 10.0607 16.0719Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default TrendingIcon;
